import type { ExperimentState } from "@hopper-b2b/types";

/**
 * Merge local debug-menu overrides into the experiments snapshot from the BFF.
 * Updates both `experiments` (read by useExperiment) and `trackingProperties`.
 */
export function applyExperimentOverrides(
  state: ExperimentState,
  overrides: Record<string, string>
): ExperimentState {
  if (Object.keys(overrides).length === 0) {
    return state;
  }

  const experiments = { ...state.experiments };
  const trackingProperties = { ...(state.trackingProperties ?? {}) };

  for (const [flagName, variant] of Object.entries(overrides)) {
    experiments[flagName] = variant;
    trackingProperties[flagName] = variant;
  }

  return {
    ...state,
    experiments,
    trackingProperties,
  };
}

export function isExperimentVariantAvailable(variant: unknown): boolean {
  if (typeof variant !== "string") {
    return false;
  }

  return variant.toLowerCase() === "available";
}
